// Anything exported from this file is importable by other in-browser modules.
// export function publicApiFunction() {}
import "./global.css?modules=false";
import {
  Provider,
  Button,
  Icon,
  Input,
  Container,
  Grid,
  FormContainer,
  Typography,
  Skeleton,
  Avatar,
  Drawer,
  Box,
  IconButton,
  Divider,
  Alert,
  Card,
  CardContent,
  CardHeader,
  Loading,
  Tooltip,
  Toggle,
  Table,
  TableHelper,
  Tag,
  Modal,
  useMediaQuery,
} from "@bem-lib/designsystem";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
  Tooltip as TooltipChart,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
  TooltipChart,
  ChartDataLabels
);

import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Avatar as AvatarMUI,
  AppBar,
  useTheme,
} from "@material-ui/core";

import {
  formatarCPF,
  formataDataResumida,
  formataDataCompleta,
  formataDataBarra,
  formataHora,
  formataDataBarraSemHora,
} from "./helpers/Formatters";

export {
  Provider,
  Button,
  Icon,
  Input,
  Container,
  Grid,
  FormContainer,
  Typography,
  Skeleton,
  Avatar,
  Drawer,
  Box,
  IconButton,
  Divider,
  Alert,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableHelper,
  formatarCPF,
  formataDataResumida,
  formataDataCompleta,
  formataDataBarra,
  formataDataBarraSemHora,
  formataHora,
  Loading,
  Tooltip,
  Toggle,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
  Bar,
  AvatarMUI,
  Tag,
  Modal,
  AppBar,
  useMediaQuery,
  useTheme,
};
